import { cn } from './cn';

/**
 * Пилюля-тумблер: чип проекта в фильтре, проект в ленте, лента у проекта. С цветом — заливка цветом
 * и белая точка, без цвета — тёмная заливка. aria-pressed — состояние; data — хук для e2e.
 */
export function TogglePill({ on, label, color, data, onClick, className }: { on: boolean; label: string; color?: string; data?: Record<string, string>; onClick: () => void; className?: string }) {
  return (
    <button
      type="button" aria-pressed={on} {...data} onClick={onClick}
      className={cn('min-h-0 inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-sm font-medium', on ? 'text-white' : 'bg-white border-gray-300 hover:bg-gray-100', on && !color && 'bg-gray-800 border-gray-800', className)}
      style={on && color ? { background: color, borderColor: color } : undefined}
    >
      {color && <span className="inline-block w-2 h-2 rounded-full" style={{ background: on ? '#fff' : color }} />}{label}
    </button>
  );
}
